import { render, staticRenderFns } from "./AccountAvatar.vue?vue&type=template&id=3b9df5ae&scoped=true"
import script from "./AccountAvatar.vue?vue&type=script&lang=js"
export * from "./AccountAvatar.vue?vue&type=script&lang=js"
import style0 from "./AccountAvatar.vue?vue&type=style&index=0&id=3b9df5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9df5ae",
  null
  
)

export default component.exports